import React, {Component} from 'react';
import { firebase } from '@firebase/app';

/**
 * Receives user props from header
 *
 * This is the login button component and deals with google oauth
 */
class OAuth extends Component {

    constructor(props) {
        console.log("OAuth constructor ", props);
        super(props);
        this.state = {
          displayName: props.user.displayName
        };
        this.authenticate = this.authenticate.bind(this);
        this.signout = this.signout.bind(this);
        this.changename = this.changename.bind(this);
        this.anonymous = this.anonymous.bind(this);
    }

    anonymous(user){
        console.log("OAuth authenticate ", user);
        firebase.auth().signInAnonymously().catch(function(error) {
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log("ERROR!!");
        });
    }
    

    authenticate(user){
        console.log("Anon authenticate ", user);
        let provider = new firebase.auth.GoogleAuthProvider();
        console.log("trying to login with " + provider);
        firebase.auth().signInWithRedirect(provider)
    }

    changename(user) {
        let newname = prompt("Set Your New Name:");
        if (!!newname && newname.length > 0){
          this.props.user.setName(newname);
          this.setState({displayName: newname});
        }
    }

    //logouts user from firebase app
    signout(user) {
        console.log("OAuth signout ", user);
        sessionStorage.clear();
        this.props.user.logout();
        return firebase.auth().signOut();
    }

    render() {
        //console.log("OAuth render");
        return (
            <div>
                <div className='oauth'>
                    {
                        //conditionally renders based on authed status(userStore.authed)
                        !this.props.user.authed
                            ?
                            // <div 
                            // style={{
                            //     display: "flex", 
                            //     position: "relative", 
                            //     // left: "-15rem"   // pushes them left, outside their parent
                            // }}
                            // >
                                <div><button onClick={this.anonymous} className="anon-sign-in button-default">
                                    Sign in Anonymously
                                </button>
                                <button onClick={this.authenticate} className="sign-in-button button-default">
                                    Sign in with Google
                                </button>
                            </div>
                            :
                            <div className="sign-out-text">
                              <div className="sign-out-name">
                                  {this.state.displayName || this.props.user.displayName}
                              </div>
                              <div className="sign-out-button">
                                <span style={{ padding: "2px" }} onClick={this.signout}>Logout</span>
                                <span style={{ padding: "2px" }} onClick={this.changename}>Edit Name</span>
                              </div>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default OAuth;



// WEBPACK FOOTER //
// ./src/components/OAuth.js